<template>
  <section class="apply-company-base">
    <table class="table">
      <tr>
        <th>
          貴社正式名
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="TORIHIKI_SAKI_MEI"
            v-slot="{ errors }"
            rules="required|max:30|char"
          >
            <b-form-input
              v-model="form.TORIHIKI_SAKI_MEI"
              ref="TORIHIKI_SAKI_MEI"
              class="col-md-6"
              maxlength="30"
              :state="errors.length ? false : null"
              placeholder="株式会社ロジコ"
              trim
              @blur="
                form.TORIHIKI_SAKI_MEI = replaceChar(form.TORIHIKI_SAKI_MEI)
              "
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>
          貴社正式名（フリガナ）
          <br v-if="isTablet" />
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="TORIHIKI_SAKI_MEI_KANA"
            v-slot="{ errors }"
            rules="required|max:30|katakana"
          >
            <b-form-input
              v-model="form.TORIHIKI_SAKI_MEI_KANA"
              ref="TORIHIKI_SAKI_MEI_KANA"
              class="col-md-6"
              maxlength="30"
              :state="errors.length ? false : null"
              placeholder="カブシキガイシャロジコ"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>
          代表者名
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="DAIHYO_MEI"
            v-slot="{ errors }"
            rules="required|max:30|char"
          >
            <b-form-input
              v-model="form.DAIHYO_MEI"
              ref="DAIHYO_MEI"
              class="col-md-6"
              maxlength="30"
              :state="errors.length ? false : null"
              placeholder="飯島  佳晴"
              trim
              @blur="form.DAIHYO_MEI = replaceChar(form.DAIHYO_MEI)"
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>
          代表者役職
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="DAIHYO_YAKUSYOKU_MEI"
            v-slot="{ errors }"
            rules="required|max:30|char"
          >
            <b-form-input
              v-model="form.DAIHYO_YAKUSYOKU_MEI"
              ref="DAIHYO_YAKUSYOKU_MEI"
              class="col-md-6"
              maxlength="30"
              :state="errors.length ? false : null"
              placeholder="代表取締役社長"
              trim
              @blur="
                form.DAIHYO_YAKUSYOKU_MEI = replaceChar(
                  form.DAIHYO_YAKUSYOKU_MEI
                )
              "
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>郵便番号</th>
        <td>
          <div class="row">
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:3"
                name="TORIHIKI_YUBIN1"
              >
                <b-form-input
                  type="tel"
                  ref="TORIHIKI_YUBIN1"
                  maxlength="3"
                  v-model="form.TORIHIKI_YUBIN1"
                  :state="errors.length ? false : null"
                  placeholder="160"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <span class="py-2">-</span>
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:4"
                name="TORIHIKI_YUBIN2"
              >
                <b-form-input
                  type="tel"
                  ref="TORIHIKI_YUBIN2"
                  maxlength="4"
                  v-model="form.TORIHIKI_YUBIN2"
                  :state="errors.length ? false : null"
                  placeholder="0023"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <button
              type="button"
              class="btn btn-success bold"
              @click="searchAddress"
              :disabled="!isYubinSearch"
              style="height: 40px"
            >
              検索
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <th>
          都道府県・市区町村
          <span class="must">必須</span>
        </th>
        <td>
          <div class="row">
            <div class="col-4 col-md-4 col-lg-3 pr-0">
              <validation-provider
                v-slot="{ errors }"
                name="TORIHIKI_TODO_CD"
                rules="required"
                ref="TORIHIKI_TODO_MEI"
              >
                <b-form-select
                  v-model="form.TORIHIKI_TODO_CD"
                  ref="TORIHIKI_TODO_CD"
                  :state="errors.length ? false : null"
                  :options="prefList"
                  trim
                  @change="changePref"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-7 col-md-5 col-lg-4">
              <validation-provider
                v-slot="{ errors }"
                name="TORIHIKI_SHIKU_CD"
                rules="required"
                ref="TORIHIKI_SHIKU_MEI"
              >
                <b-form-select
                  :disabled="!cityList.length"
                  ref="TORIHIKI_SHIKU_CD"
                  v-model="form.TORIHIKI_SHIKU_CD"
                  :state="errors.length ? false : null"
                  :options="cityList"
                  trim
                  @change="changeCity"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>
          番地建物名
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="TORIHIKI_BANCHI"
            v-slot="{ errors }"
            rules="required|max:25|char"
          >
            <b-form-input
              maxlength="25"
              ref="TORIHIKI_BANCHI"
              v-model="form.TORIHIKI_BANCHI"
              :state="errors.length ? false : null"
              placeholder="西新宿7－4－3 升本ビル4F"
              trim
              @blur="form.TORIHIKI_BANCHI = replaceChar(form.TORIHIKI_BANCHI)"
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>
          TEL
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="TORIHIKI_SAKI_TEL"
            v-slot="{ errors }"
            rules="required|tel"
          >
            <b-form-input
              class="col-md-6"
              ref="TORIHIKI_SAKI_TEL"
              maxlength="17"
              v-model="form.TORIHIKI_SAKI_TEL"
              :state="errors.length ? false : null"
              placeholder="03-5937-4777"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>FAX</th>
        <td>
          <validation-provider
            name="TORIHIKI_SAKI_FAX"
            v-slot="{ errors }"
            rules="fax"
          >
            <b-form-input
              class="col-md-6"
              ref="TORIHIKI_SAKI_FAX"
              maxlength="17"
              v-model="form.TORIHIKI_SAKI_FAX"
              :state="errors.length ? false : null"
              placeholder="03-5937-6666"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

export default {
  name: 'CompanyBaseInfo',

  mixins: [Mixin],

  props: {
    /** データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** オブザーバー */
    observer: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 市区町村リスト */
    cityList: [],

    /** 入力データ */
    form: {
      TORIHIKI_SAKI_MEI: null,
      TORIHIKI_SAKI_MEI_KANA: null,
      DAIHYO_YAKUSYOKU_MEI: null,
      DAIHYO_MEI: null,
      TORIHIKI_YUBIN1: null,
      TORIHIKI_YUBIN2: null,
      TORIHIKI_TODO_MEI: null,
      TORIHIKI_TODO_CD: null,
      TORIHIKI_SHIKU_MEI: null,
      TORIHIKI_BANCHI: null,
      TORIHIKI_SHIKU_CD: '',
      TORIHIKI_SAKI_TEL: null,
      TORIHIKI_SAKI_FAX: null,
    },
  }),

  methods: {
    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.TORIHIKI_TODO_CD
      this.form.TORIHIKI_TODO_MEI = null
      this.form.TORIHIKI_SHIKU_CD = ''
      this.form.TORIHIKI_SHIKU_MEI = null
      if (todoCd) {
        this.form.TORIHIKI_TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.TORIHIKI_SHIKU_CD
      this.form.TORIHIKI_SHIKU_MEI = null
      if (shikuCd) {
        this.form.TORIHIKI_SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.TORIHIKI_TODO_CD) return
      return Store.dispatch(
        'address/getCityList',
        this.form.TORIHIKI_TODO_CD
      ).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
      })
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.TORIHIKI_YUBIN1}${this.form.TORIHIKI_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.TORIHIKI_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.TORIHIKI_TODO_MEI = this.getText(
            this.prefList,
            this.form.TORIHIKI_TODO_CD
          )
          this.form.TORIHIKI_SHIKU_MEI = item.address2
          this.form.TORIHIKI_BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.TORIHIKI_SHIKU_MEI,
            'text'
          )
          if (city) this.form.TORIHIKI_SHIKU_CD = city.value
        }
      })
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.TORIHIKI_YUBIN1 &&
        this.form.TORIHIKI_YUBIN2 &&
        this.observer &&
        this.observer.fields.TORIHIKI_YUBIN1 &&
        this.observer.fields.TORIHIKI_YUBIN2 &&
        !this.observer.fields.TORIHIKI_YUBIN1.failed &&
        !this.observer.fields.TORIHIKI_YUBIN2.failed
      )
    },
  },

  watch: {
    /** データ取得イベント監視 */
    async isGetData(val) {
      if (val) this.$emit('setData', this.form)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/apply/CompanyBaseInfo.vue